// CAT Mock 7 — DILR section.
const di1Statement = `The table shows the revenue and expenses (in ₹ crore) of five firms, V–Z, in 2023 and 2024. Profit is defined as revenue minus expenses.`;
const di1Table = {
  columns: ["Firm", "Revenue 2023", "Revenue 2024", "Expenses 2023", "Expenses 2024"],
  rows: [
    ["V", "200", "240", "160", "186"],
    ["W", "150", "165", "120", "138"],
    ["X", "300", "330", "255", "270"],
    ["Y", "120", "156", "102", "129"],
    ["Z", "250", "260", "190", "210"]
  ]
};

const di2Statement = `Six friends — P, Q, R, S, T and U — sit around a circular table, equally spaced and facing the centre. Each likes a different fruit: apple, banana, cherry, grape, mango and orange.
• Q sits directly opposite P.
• R sits immediately clockwise of P.
• S sits next to P.
• U sits next to Q but not next to S.
• The person who likes mango sits immediately clockwise of the person who likes apple.
• The person who likes banana sits directly opposite the person who likes apple.
• The person who likes orange sits between the person who likes banana and the person who likes cherry.
• R likes neither apple nor cherry.
• U likes grape.`;

const di3Statement = `Each of the 200 students in a college may study any number of three languages — French, German and Spanish — or none of them. It is known that:
• 73 students study French, 67 study German and 65 study Spanish.
• 10 students study all three languages.
• 35 students study exactly two of the languages.
• 40 students study only French, and 30 study only German.`;

const di4Statement = `Five teams — J, K, L, M and N — took part in a tournament in which each team played every other team exactly once. A win earned 2 points, a draw 1 point and a loss 0 points. The final points are shown in the table. It is also known that:
• Exactly two matches ended in a draw.
• N drew its match against J.`;
const di4Table = {
  columns: ["Team", "Matches played", "Points"],
  rows: [
    ["J", "4", "7"],
    ["K", "4", "5"],
    ["L", "4", "4"],
    ["M", "4", "3"],
    ["N", "4", "1"]
  ]
};

const catMock7Dilr = [
  {
    id: 25,
    type: "mcq",
    setId: "di1",
    statement: di1Statement,
    table: di1Table,
    question: "Which firm recorded the highest percentage growth in revenue from 2023 to 2024?",
    options: [
      "A. V",
      "B. Y",
      "C. X",
      "D. W"
    ],
    answer: "B"
  },
  {
    id: 26,
    type: "tita",
    setId: "di1",
    statement: di1Statement,
    table: di1Table,
    question: "For how many firms was the profit in 2024 strictly greater than the profit in 2023?",
    answer: "3"
  },
  {
    id: 27,
    type: "mcq",
    setId: "di1",
    statement: di1Statement,
    table: di1Table,
    question: "Profit margin is defined as profit as a percentage of revenue. Which firm had the highest profit margin in 2024?",
    options: [
      "A. Z",
      "B. X",
      "C. V",
      "D. Y"
    ],
    answer: "C"
  },
  {
    id: 28,
    type: "tita",
    setId: "di1",
    statement: di1Statement,
    table: di1Table,
    question: "What was the combined profit of all five firms in 2024 (in ₹ crore)?",
    answer: "218"
  },
  {
    id: 29,
    type: "mcq",
    setId: "di1",
    statement: di1Statement,
    table: di1Table,
    question: "By approximately what percentage did the combined profit of the five firms grow from 2023 to 2024?",
    options: [
      "A. 11%",
      "B. 15%",
      "C. 9%",
      "D. 13%"
    ],
    answer: "D"
  },
  {
    id: 30,
    type: "mcq",
    setId: "di2",
    statement: di2Statement,
    question: "Who sits directly opposite R?",
    options: [
      "A. U",
      "B. S",
      "C. T",
      "D. Q"
    ],
    answer: "C"
  },
  {
    id: 31,
    type: "mcq",
    setId: "di2",
    statement: di2Statement,
    question: "Which fruit does S like?",
    options: [
      "A. Orange",
      "B. Cherry",
      "C. Banana",
      "D. Mango"
    ],
    answer: "B"
  },
  {
    id: 32,
    type: "tita",
    setId: "di2",
    statement: di2Statement,
    question: "Moving clockwise from P, how many people sit between P and U?",
    answer: "1"
  },
  {
    id: 33,
    type: "mcq",
    setId: "di2",
    statement: di2Statement,
    question: "Who likes orange?",
    options: [
      "A. T",
      "B. S",
      "C. U",
      "D. R"
    ],
    answer: "A"
  },
  {
    id: 34,
    type: "mcq",
    setId: "di2",
    statement: di2Statement,
    question: "Which of the following statements is true?",
    options: [
      "A. R likes banana.",
      "B. T sits immediately clockwise of Q.",
      "C. S likes mango.",
      "D. U sits directly opposite P."
    ],
    answer: "B"
  },
  {
    id: 35,
    type: "tita",
    setId: "di2",
    statement: di2Statement,
    question: "The seats are numbered 1 to 6 clockwise, with P in seat 1. In which seat does the person who likes banana sit?",
    answer: "4"
  },
  {
    id: 36,
    type: "tita",
    setId: "di3",
    statement: di3Statement,
    question: "How many students study none of the three languages?",
    answer: "50"
  },
  {
    id: 37,
    type: "mcq",
    setId: "di3",
    statement: di3Statement,
    question: "How many students study only Spanish?",
    options: [
      "A. 30",
      "B. 40",
      "C. 45",
      "D. 35"
    ],
    answer: "D"
  },
  {
    id: 38,
    type: "tita",
    setId: "di3",
    statement: di3Statement,
    question: "How many students study French and German but not Spanish?",
    answer: "15"
  },
  {
    id: 39,
    type: "mcq",
    setId: "di3",
    statement: di3Statement,
    question: "How many students study at least two of the three languages?",
    options: [
      "A. 45",
      "B. 35",
      "C. 55",
      "D. 40"
    ],
    answer: "A"
  },
  {
    id: 40,
    type: "mcq",
    setId: "di3",
    statement: di3Statement,
    question: "How many students study exactly one of the three languages?",
    options: [
      "A. 95",
      "B. 110",
      "C. 105",
      "D. 100"
    ],
    answer: "C"
  },
  {
    id: 41,
    type: "tita",
    setId: "di4",
    statement: di4Statement,
    table: di4Table,
    question: "How many matches did K win?",
    answer: "2"
  },
  {
    id: 42,
    type: "mcq",
    setId: "di4",
    statement: di4Statement,
    table: di4Table,
    question: "Against which team did M draw?",
    options: [
      "A. J",
      "B. L",
      "C. N",
      "D. K"
    ],
    answer: "D"
  },
  {
    id: 43,
    type: "tita",
    setId: "di4",
    statement: di4Statement,
    table: di4Table,
    question: "How many matches did L lose?",
    answer: "2"
  },
  {
    id: 44,
    type: "mcq",
    setId: "di4",
    statement: di4Statement,
    table: di4Table,
    question: "Which of the following statements is true?",
    options: [
      "A. L beat K.",
      "B. J drew with K.",
      "C. M beat N.",
      "D. N beat M."
    ],
    answer: "C"
  },
  {
    id: 45,
    type: "tita",
    setId: "di4",
    statement: di4Statement,
    table: di4Table,
    question: "If a win had earned 3 points instead of 2 (with a draw still earning 1 point), how many points would J have scored?",
    answer: "10"
  },
  {
    id: 46,
    type: "mcq",
    setId: "di4",
    statement: di4Statement,
    table: di4Table,
    question: "If a win had earned 3 points instead of 2 (with a draw still earning 1 point), which team would have finished second?",
    options: [
      "A. L",
      "B. K",
      "C. K and L, tied",
      "D. J"
    ],
    answer: "B"
  }
];

export default catMock7Dilr;
